import { AvailableFlightTab } from '../../../../shared/graphql-types';

export class FilterOptions {
  intId: string = null;
  departureDate: Date = null;
  tailNumber: string = null;
  tab: AvailableFlightTab = AvailableFlightTab.Upcoming;
}
